import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import Loan_SchemesTable from './Loan_SchemesTable'
import Loan_SchemesHeader from './Loan_SchemesHeader'

const Loan_SchemesList = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader >
                        <Loan_SchemesHeader />
                    </PageHeader>
                    <div className='main-content'>
                        <div className='row'>
                            <Loan_SchemesTable />
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>
        </>
    )
}

export default Loan_SchemesList